// Question types
const OPTIONS = 1;
const TEXT = 2;
const TEXT_AND_FILES = 3;
const SORTED_OPTIONS = 4;
const MATCHING_PAIRS = 5;
const TEXT_VARIANTS = 6;

// Answer types
const TEXT_INPUT = 1;
const FILE_INPUT = 2;

export const QUESTION_TYPES = {
  [OPTIONS]: {
    name: 'Выбор из варианта',
    value: OPTIONS,
    icon: 'mdi-format-list-checks',
    serializer: (options) =>
      options.map((option) => ({
        ...(option.id ? { id: option.id } : {}),
        ...(option.name ? { name: option.name } : {}),
        ...(option.image ? { image: option.image?.url } : {}),
        ...(option.score != null ? { score: option.score } : {}),
        ...(option.is_correct !== null ? { is_correct: option.is_correct } : {}),
      })),
  },
  [TEXT]: {
    name: 'Текстовый ответ',
    value: TEXT,
    icon: 'mdi-text',
    serializer: (data) => data,
  },
  [TEXT_VARIANTS]: {
    name: 'Текстовый ответ с вариантами',
    value: TEXT_VARIANTS,
    icon: 'mdi-text',
    serializer: (options) =>
      options.map((option) => ({
        ...(option.id ? { id: option.id } : {}),
        ...(option.name ? { name: option.name } : {}),
        ...(option.score != null ? { score: option.score } : {}),
      })),
  },
  [TEXT_AND_FILES]: {
    name: 'Вложения',
    value: TEXT_AND_FILES,
    icon: 'mdi-paperclip',
    serializer: (data) => data,
  },
  [SORTED_OPTIONS]: {
    name: 'Сортировка объектов',
    value: SORTED_OPTIONS,
    icon: 'mdi-mdi-format-list-checks',
    serializer: (data) => data,
  },
  [MATCHING_PAIRS]: {
    name: 'Сопоставление пар объектов',
    value: MATCHING_PAIRS,
    icon: 'mdi-format-list-checks',
    serializer: (options) =>
      options.map((pair) => ({
        pair: pair.map((option) => ({
          ...(option.id ? { id: option.id } : {}),
          ...(option.name ? { name: option.name } : {}),
          ...(option.image ? { image: option.image?.url } : {}),
          ...(option.score != null ? { score: option.score } : {}),
        })),
      })),
  },
};

export const ANSWER_TYPES_NAMES = {
  text: TEXT_INPUT,
  file: FILE_INPUT,
};

export const ANSWER_TYPES_LIST = [
  { value: TEXT_INPUT, text: 'Текст' },
  { value: FILE_INPUT, text: 'Файл' },
];

export const QUESTION_TYPES_NAMES = {
  options: OPTIONS,
  text: TEXT,
  textAndFiles: TEXT_AND_FILES,
  sortedOptions: SORTED_OPTIONS,
  matchingPairs: MATCHING_PAIRS,
  textVariants: TEXT_VARIANTS,
};

// Mixed Question Fields
const IS_TEXT_REQUIRED = 'is_text_required';
const IS_DOCUMENTS_REQUIRED = 'is_document_required';
const IS_IMAGE_REQUIRED = 'is_image_required';
const IS_LINK_REQUIRED = 'is_link_required';

export const ATTACHMENT_TYPES = {
  [IS_TEXT_REQUIRED]: {
    name: 'Текст',
    type: 'text',
    helperText: 'Допускается вставка текста до 2000 символов',
  },
  [IS_DOCUMENTS_REQUIRED]: {
    name: 'Документы',
    type: 'documents',
    helperText: 'Допустимые текстовые файлы pdf, doc, docx, excel, powerpoint размером до 5 мб. Не более 10 документов',
  },
  [IS_IMAGE_REQUIRED]: {
    name: 'Картинка',
    type: 'image',
    helperText: 'Допускается прикрепление изображений в форматах png, jpeg, jpg размером до 5 мб каждый. Не более 10 изображений',
  },
  [IS_LINK_REQUIRED]: {
    name: 'Ссылка',
    type: 'link',
    helperText: `Прикрепление ссылки на внешние ресурсы, например, google диск, яндекс диск и т.д.
      Также можно использовать ссылки на видеосервисы Youtube и Rutube. Не более 10 ссылок`,
  },
};

export const POLL_TYPES = {
  TESTING: 1,
  ATTACHMENT: 2,
};

export const POLL_QUESTION_TYPES = {
  [POLL_TYPES.TESTING]: [QUESTION_TYPES[OPTIONS], QUESTION_TYPES[MATCHING_PAIRS], QUESTION_TYPES[TEXT_VARIANTS]],
  [POLL_TYPES.ATTACHMENT]: [QUESTION_TYPES[TEXT], QUESTION_TYPES[TEXT_AND_FILES]],
};

export const POLL_TYPES_TEXT = [
  { text: 'Автоматизированное тестирование', val: POLL_TYPES.TESTING },
  { text: 'Экспертная проверка', val: POLL_TYPES.ATTACHMENT },
];

export const FOLDER_TYPES = {
  task: 1,
  template: 2,
};

export const FOLDER_TYPES_NAMES = {
  [FOLDER_TYPES.task]: 'Задание',
  [FOLDER_TYPES.template]: 'Шаблон',
};

// PollPassing need it (deprecated)
export const POLL_UNIT_TYPES = {
  // readingMark: 1,
  // link: 4,
  // file: 5,
  // choiceOptions: 10,
  CHOICE_OPTION: 1,
  TEXT_OPTION: 2,
};

export const SETTINGS_KEYS = {
  main: 'main',
  dates: 'dates',
  categories: 'categories',
};

export const POLL_STATUS = {
  active: 1,
};

export const GROUP_TYPE = {
  pollFolders: 'poll-folders',
  expertiseGroups: 'expertise-groups',
};
